import React, { PureComponent } from "react";
import ReactWOW from 'react-wow';
import i18n from 'i18next'

class Logo extends PureComponent {
  render() {
    return (
      <a href={this.props.link} target="_blank" rel="noopener noreferrer" className="link">
        {
          this.props.image
            ? <img src={"images/partners/" + this.props.image} alt={i18n.t(this.props.name)} className="img-logo" />
            : (
              <div>
                <span className="display-name">{i18n.t(this.props.displayName)}</span><br/>
                <span className="subtext">{i18n.t(this.props.subtext)}</span>
              </div>
            )
        }
        <p className="name">{i18n.t(this.props.name)}</p>
      </a>
    )
  }
}

class PartnerItem extends PureComponent {
  render() {
    const item = this.props;
    return (
      <ReactWOW animation="fadeInUp" delay="0.1s">
        <div className="flex-item">
          <Logo
            name={item.name}
            image={item.image}
            link={item.link}
            displayName={item.displayName}
            subtext={item.subtext}
          />
        </div>
      </ReactWOW>
    )
  }
}

class Partners extends React.Component {
  render() {
    const msg = this.props.Message;
    return (
      <section id="partners">
        <div className="container">
          <div className="title-block">
            <h2>{i18n.t(msg.partners)}</h2>
          </div>
          {/* Training Partners */}
          <h4>{i18n.t(msg.organized)}</h4>
          <div className="flex-container">
            {
              msg.organizedData.map((item, index) => {
                return <PartnerItem {...item} key={index} />
              })
            }
          </div>
          {/* Goverment Partners */}
          <h4>{i18n.t(msg.governmentPartner)}</h4>
          <div className="flex-container">
            {
              msg.governmentPartnerData.map((item, index) => {
                return <PartnerItem {...item} key={index} />
              })
            }
          </div>
          {/* school Partners */}
          <h4>{i18n.t(msg.schoolPartner)}</h4>
          <div className="flex-container">
            {
              msg.schoolData.map((item, index) => {
                return <PartnerItem {...item} key={index} />
              })
            }
          </div>
          {/* University Partners */}
          <h4>{i18n.t(msg.universityPartners)}</h4>
          <div className="flex-container">
            {
              msg.universityPartnersData.map((item, index) => {
                return <PartnerItem {...item} key={index} />
              })
            }
          </div>
          {/* Support Partners */}
          <h4>{i18n.t(msg.supportPartners)}</h4>
          <div className="flex-container">
            {
              msg.supportPartnersData.map((item, index) => {
                return <PartnerItem {...item} key={index} />
              })
            }
          </div>
          {/* Partnership Opportunities */}
          <h4>{i18n.t(msg.partnershipOpportunities)}</h4>
          <div>
            {
              msg.partnershipOpportunitiesData.map(item => 
                <div className="opportunities" key={item.title}>
                  <p className="title">{i18n.t(item.title)}</p>
                  <ul>
                    {
                      item.desc.map(desc => <li key={desc} dangerouslySetInnerHTML={{ __html: i18n.t(desc) }} />)
                    }
                  </ul>
                </div>
              )
            }
          </div>
        </div>
      </section>
    );
  }
}

export default Partners;